// src/utils/uploadFile.js

import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

/**
 * 
 * @param {File} file Yüklenecek dosya
 * @param {(progress: number) => void} onProgress Yüzde (0-100) bilgisini vereceğimiz callback
 * @returns {Promise<string>} Dosyanın indirme (download) URL’si
 */

export const uploadFile = (file, onProgress) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      return reject(new Error('Dosya bulunamadı'));
    }

    // Boyut kontrolü isteniyorsa buraya ekleyebilirsiniz
    const maxSize = 1024 * 1024 * 1024; // 1 GB
    if (file.size > maxSize) {
       return reject(new Error('Dosya boyutu 1GB\'ı aşıyor.'));
    }

    const fileName = `${Date.now()}_${file.name}`;
    const storageRef = ref(storage, `attachments/${fileName}`);

    // Artık uploadBytes yerine uploadBytesResumable:
    const uploadTask = uploadBytesResumable(storageRef, file);

    // Her adımda state'i izlemek için:
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (onProgress) {
          onProgress(progress); // Yüzde (0-100)
        }
      },
      (error) => {
        reject(error);
      },
      async () => {
        // Yükleme başarıyla tamamlandığında:
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
        } catch (err) {
          reject(err);
        }
      }
    );
  });
};